var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("header", [
    _c(
      "div",
      { attrs: { id: "evaluation-participants", "data-cy": "debtor-info" } },
      [
        _c("div", { staticClass: "columns mb-4" }, [
          _c(
            "div",
            { staticClass: "column" },
            [_c("EvaluationDebtor", { attrs: { debtor: _vm.debtor } })],
            1
          ),
        ]),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }